import React, { useEffect } from 'react';
import { Dropdown, MenuProps, Radio, RadioChangeEvent } from 'antd';
import { useAppDispatch } from '../../../../utilities/hooks';
import { setterSchedule } from '../../../../slices/scheduleSlice';
import { SchedulePageViewType, ScheduleViewType } from '../../../../types';
import { useAccess } from '@sitemax/smx-permission';
import { AccessContainer, CalendarViewType, useRouting } from '@sitemax/smx-components';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store';

const ButtonScale = () => {
    const dispatch = useAppDispatch();
    const schedulePageView = useSelector<RootState, SchedulePageViewType | undefined>(
        (state) => state.schedule.schedulePageView,
    );
    const isAccessWorkItems = useAccess(['work-item.view']);
    const isAccessTask = useAccess(['schedule-task.view']);

    const { navigate, getParams, setUrlParam, getUrlPath } = useRouting();

    const onChangeScale = ({ target: { value } }: RadioChangeEvent) => {
        dispatch(setterSchedule({ schedulePageView: value }));
    };

    useEffect(() => {
        let view: ScheduleViewType = 'calendar';
        let activeCalendarPage: CalendarViewType = 'schedule';

        if (schedulePageView === 'timeline') {
            view = 'gant';
        }

        if (schedulePageView === 'schedule') {
            activeCalendarPage = 'schedule';
        }

        if (schedulePageView === 'board') {
            view = 'taskBoard';
        }

        if (['listTask', 'listItem', 'list', 'table'].includes(schedulePageView || '')) {
            activeCalendarPage = 'table';
        }

        dispatch(setterSchedule({ activeCalendarPage, view }));

        switch (schedulePageView) {
            case 'list':
                navigate('/schedule/table');
                break;
            case 'listItem':
                navigate('/schedule/table/items');
                break;
            case 'listTask':
                navigate('/schedule/table/tasks');
                break;
            case 'timeline':
                navigate('/schedule/timeline');
                break;
            case 'board':
                navigate('/schedule/task-board');
                break;
            case 'schedule':
                navigate('/schedule/calendar');
                break;
        }
    }, [schedulePageView]);

    const clickToSwitchToScheduleItem = () => {
        dispatch(setterSchedule({ schedulePageView: isAccessWorkItems ? 'listItem' : 'listTask' }));
    };

    const clickToSwitchToTask = () => {
        dispatch(setterSchedule({ schedulePageView: isAccessTask ? 'listTask' : 'listItem' }));
    };

    const items: MenuProps['items'] = [
        isAccessWorkItems
            ? {
                  key: '2',
                  label: 'Schedule Item',
                  onClick: clickToSwitchToScheduleItem,
              }
            : null,
        isAccessTask
            ? {
                  key: '1',
                  label: 'Task',
                  onClick: clickToSwitchToTask,
              }
            : null,
    ];

    const getValue = () => {
        if (!schedulePageView) {
            return 'timeline';
        }

        return ['listTask', 'listItem'].includes(schedulePageView) ? 'list' : schedulePageView;
    };

    return (
        <Radio.Group value={getValue()} optionType="button">
            {isAccessWorkItems && isAccessTask && (
                <Dropdown menu={{ items }} placement="bottomLeft">
                    <Radio.Button value={'list'} onClick={clickToSwitchToScheduleItem}>
                        List
                    </Radio.Button>
                </Dropdown>
            )}
            {(!isAccessWorkItems || !isAccessTask) && (
                <Radio.Button value={'list'} onClick={clickToSwitchToScheduleItem}>
                    List
                </Radio.Button>
            )}
            <AccessContainer accessFor={['work-item.view']}>
                <Radio.Button value={'timeline'} onChange={onChangeScale}>
                    Timeline
                </Radio.Button>
            </AccessContainer>
            <AccessContainer accessFor={['schedule-task.view']}>
                <Radio.Button value={'schedule'} onChange={onChangeScale}>
                    Calendar
                </Radio.Button>
            </AccessContainer>
            <AccessContainer accessFor={['schedule-task.view']}>
                <Radio.Button value={'board'} onChange={onChangeScale}>
                    Board
                </Radio.Button>
            </AccessContainer>
        </Radio.Group>
    );
};

export default ButtonScale;
